import Logger from '@/search-page/platform/Logger';

class DeduplicatedErrorLogger {
	private errors: Set<string> = new Set();

	public logDeduplicatedError = (error: string): void => {
		if (this.errors.has(error)) {
			return;
		}
		this.errors.add(error);
		Logger.logError(error);
	};
}

export const deduplicatedLogger = new DeduplicatedErrorLogger();
